<div class="widget-top-container d-flex justify-content-space-between">
  <h1>{{widgetData.title}}</h1>
  <a (click)="openPopup()" class="link">
    <span>{{widgetData.allBookmarksPopupLinkText}}</span>
  </a>
</div>

<div class="items-container" *ngIf="!isLoading">
  <ng-container *ngIf="selectedBookmarks?.length; else noItemsTemplate">
    <ng-template ngFor let-bookmark [ngForOf]="selectedBookmarks">
      <a [href]="bookmark.link" class="bookmark-item">
        <img class="bookmark-icon" [src]="bookmark.iconUrl">
        <span class="bookmark-text">{{bookmark.title}}</span>
      </a>
    </ng-template>
  </ng-container>
  
  <ng-template #noItemsTemplate>
    <p class="no-results-label">{{widgetData.noBookmarksSelectedText}}</p>
  </ng-template>
</div>

<div class="items-container skeleton" *ngIf="isLoading">
  <div class="bookmark-item" *ngFor="let _ of [].constructor(5)">
    <app-skeleton [width]="38" [height]="38" [borderRadius]="10" [additionalClasses]="['bookmark-icon']"/>
    <app-skeleton class="bookmark-text" [type]="'text'" [symbolsCount]="7" />
  </div>
</div>